'use strict'

const u = require('universalify').fromCallback
module.exports = {
  copy: u(require('./copy'))
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/~/fs-extra/lib/copy/index.js
// module id = 2038
// module chunks = 0 1